/** Número da versão publicada — não intercepta clique. */
export function HintBar({ rotulo }: { rotulo?: string }) {
  if (!rotulo) return null;
  return (
    <footer className="hintbar" aria-label={rotulo}>
      {rotulo}
    </footer>
  );
}
